class EmeSummerCountdown extends HTMLElement {
  connectedCallback() {
    if (this._timer) return;
    this._deadline = new Date(this.dataset.deadline).getTime();
    this._update();
    this._timer = window.setInterval(() => this._update(), 1000);
  }

  disconnectedCallback() {
    if (this._timer) window.clearInterval(this._timer);
    this._timer = null;
  }

  _update() {
    const remaining = Math.max(0, this._deadline - Date.now());
    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const values = { days, hours, minutes, seconds };
    Object.entries(values).forEach(([key, value]) => {
      const node = this.querySelector(`[data-${key}]`);
      if (node) node.textContent = String(value).padStart(2, '0');
    });

    this.setAttribute(
      'aria-label',
      remaining > 0
        ? `La oferta termina en ${days} días, ${hours} horas, ${minutes} minutos y ${seconds} segundos`
        : 'La oferta de verano ha finalizado'
    );

    if (remaining === 0) {
      const label = this.querySelector('.eme-summer-countdown__label');
      if (label) label.textContent = 'La oferta de verano ha finalizado';
      if (this._timer) window.clearInterval(this._timer);
      this._timer = null;
    }
  }
}

if (!customElements.get('eme-summer-countdown')) {
  customElements.define('eme-summer-countdown', EmeSummerCountdown);
}
